import { Routes } from '@angular/router';

export const PHARMA_ML_ROUTES: Routes = [
  {
    path: '',
    pathMatch: 'full',
    redirectTo: 'speech-analytics'
  },
  {
    path: 'speech-analytics',
    data: { breadcrumb: null },
    loadChildren: () =>
      import('./speech-analytics/speech-analytics.routes').then(
        (r) => r.SPEECH_ANALYTICS_ROUTES
      )
  },
  {
    path: 'audience-analytics',
    data: { breadcrumb: 'Аналитика аудитории' },
    loadComponent: () =>
      import('./audience-analytics/wizard/wizard-shell.component').then(
        (c) => c.WizardShellComponent
      )
  }
];
